<script setup>
import IconHubCal from '../icons/IconHubCal.vue';
import IconHubPhone from '../icons/IconHubPhone.vue';
import IconHubPlus from '../icons/IconHubPlus.vue';
import XlButton from './XlButton.vue';

const props = defineProps({
  headline: { type: String, required: true },
  body: { type: String, default: '' },
  actions: { type: Array, default: () => [] },
});

const emit = defineEmits(['action']);

const ACTION_ICONS = { plus: IconHubPlus, phone: IconHubPhone };
</script>

<template>
  <div class="xl-quiet" role="status">
    <span class="xl-quiet__icon" aria-hidden="true"><IconHubCal :size="22" /></span>
    <div class="xl-quiet__text">
      <b class="xl-quiet__headline">{{ props.headline }}</b>
      <div v-if="props.body" class="xl-quiet__body">{{ props.body }}</div>
    </div>
    <XlButton
      v-for="action in props.actions"
      :key="action.id"
      variant="ghost"
      size="sm"
      :data-testid="`quiet-${action.id}`"
      @click="emit('action', action.id)"
    >
      <template v-if="ACTION_ICONS[action.icon]" #icon><component :is="ACTION_ICONS[action.icon]" :size="14" /></template>
      {{ action.label }}
    </XlButton>
  </div>
</template>

<style scoped>
.xl-quiet, .xl-quiet * { box-sizing: border-box; }

.xl-quiet {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  padding: 22px 24px;
  border: 1px dashed var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  background: var(--xl-color-surface);
  box-shadow: var(--xl-shadow-1);
  color: var(--xl-color-primary-text);
  font-family: var(--xl-font-family);
}

.xl-quiet__icon {
  display: grid;
  place-items: center;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: 13px;
  background: #F6F2F8;
  color: #B6AEBC;
}

.xl-quiet__text { flex: 1; min-width: 220px; }
.xl-quiet__headline { font-size: 15px; font-weight: 700; color: var(--xl-color-primary-text); }
.xl-quiet__body { font-size: 13.5px; color: #756D7C; }
</style>
